import { render, staticRenderFns } from "./TabFarmacias.vue?vue&type=template&id=16950d4b&scoped=true&"
import script from "./TabFarmacias.vue?vue&type=script&lang=js&"
export * from "./TabFarmacias.vue?vue&type=script&lang=js&"
import style0 from "./TabFarmacias.vue?vue&type=style&index=0&id=16950d4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16950d4b",
  null
  
)

export default component.exports